import React from 'react'
import {
  Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography
} from '@material-ui/core'

const CompleteCycleDialog = ({ open, loading, error, onClose, onComplete }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Complete Spray Cycle</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Complete this spray cycle and reset the schedule for the next application. Save the current spray scope for the next cycle?
      </DialogContentText>
      {error && (
        <Typography color="error" variant="body2" style={{ marginTop: 8 }}>
          {error}
        </Typography>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={loading}>Cancel</Button>
      <Button onClick={() => onComplete('preserve')} color="default" disabled={loading}>
        Keep Current Scope
      </Button>
      <Button onClick={() => onComplete('reset')} color="primary" variant="contained" disabled={loading}>
        {loading ? 'Completing...' : 'Reset Scope (All Areas)'}
      </Button>
    </DialogActions>
  </Dialog>
)

export default CompleteCycleDialog
